import { computed, watch } from 'vue';
import router from '@/router';
import { getGameConfigById } from '@/hooks/useGameConfig';
import { useGameStore } from '@/store/modules/game';
export const UseGetCurrentGameConfigHooks = function () {
  const route = router.currentRoute.value;
  const {
    setCurrentGameId
  } = useGameStore();
  const currentGameConfig = computed(function () {
    return getGameConfigById(route.path);
  });
  watch(function () {
    return currentGameConfig.value;
  }, function (val) {
    setCurrentGameId(val.id);
  }, {
    immediate: true,
    deep: true
  });
  return {
    currentGameConfig
  };
};